import { COLORS, SCREEN_MD } from "shared/consts";
import { toEm, toRem } from "shared/helpers"
import styled from "styled-components"

export const EmployeesHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(12)};
  padding: ${toRem(16)} 0;
`
type EmployeesHeadRowProps = {
  $overflow?: string;
}
export const EmployeesHeadRow = styled.div<EmployeesHeadRowProps>`
  display: flex;
  gap: ${toRem(12)};
  overflow: ${props => props.$overflow || 'initial'};
  scrollbar-width: none;

  .popover__root {
    width: max-content;
    max-width: 100%;
  }

  .tagitem__label {
    &:has(svg) {
      display: flex;
      justify-content:center;align-items: center;
    }
  }

  @media (width < ${toRem(768)}){
    gap: ${toRem(8)};
    flex-direction: column;
  }
`

export const DateWrapper = styled.div`
  --max-width: ${toRem(220)};
  max-width: var(--max-width);
  flex: 0 1 var(--max-width);

  .input {
    min-width: 0;
    margin-top: 0;
  }
  .popover__root {
    width: 100%;
  }

  @media (width < ${toEm(1200)}){
    --max-width: ${toRem(180)};
  }

  @media (width >= ${toRem(768)}){
    .dropdown,
    .popover__root {
      width: 100%;
      max-width: var(--max-width);
    }
  }

  @media (width < ${toRem(768)}){
    --max-width: none;
    .dropdown {
      width: 100%;
    }
  }
`

export const EmployeesMobileTable = styled.div`
  margin: 0 ${toRem(-16)};
  background-color: ${COLORS.BG.PAGE_FILLED};
  min-height: calc(100dvh - ${toRem(220)});
  padding: ${toRem(8)} ${toRem(16)} ${toRem(62)};
`;

export const EmployeeAddWrapper = styled.form`
  padding: ${toRem(22)} ${toRem(24)} ${toRem(20)};

  @media (width >= ${toEm(SCREEN_MD)}){
    width: ${toRem(343)};
  }
  @media (width < ${toEm(SCREEN_MD)}){
    height: 100dvh;
    display: flex;
    flex-direction: column;
  }
`;

export const EmployeeAddHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${toRem(12)};
  padding: ${toRem(16)} 0;
`;

export const EmployeeAddTitle = styled.div`
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${20 / 16};
`;

export const EmployeeAddBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(20)};
  padding: ${toRem(16)} 0;
  flex: 1 1 auto;

  >p {
    text-align: center;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
    color: ${COLORS.FG.SOFT};
  }
`;

export const EmployeeAddInput = styled.div`
  position: relative;

  .input {
    position: relative;
    &__hint {
      position: absolute;
    }
  }
`;

export const EmployeeAddEmployee = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};

  >p {
    font-weight: 500;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }
`;

export const EmployeeAddFooter = styled.div`
  display: flex;
  flex-direction: column;
`;

type EmployeeProps = {
  $isMain?: boolean;
}
export const Employee = styled.div<EmployeeProps>`
  padding: ${toRem(16)};
  border-radius: ${toRem(16)};
  background-color: ${props => !props.$isMain ? COLORS.BG.SURFACE2 : COLORS.BG.PAGE};
  display: grid;
  grid-template-columns: ${toRem(36)} auto;
  gap: ${toRem(12)};
  position: relative;

  &:not(:last-child) {margin-bottom: ${toRem(8)};}
`;

export const EmployeeAvatar = styled.div`
  width: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const EmployeeBody = styled.div`
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
`;

export const EmployeeName = styled.p`
  font-weight: 500;
`;

export const EmployeeEmail = styled.p`
  color: ${COLORS.FG.SOFT};
  &:not(:last-child) {margin-bottom: ${toRem(8)};}
`;

export const EmployeeInfoRow = styled.div`
  display: flex;
  gap: ${toRem(4)};

  span {
    color: ${COLORS.FG.MUTED};
  }

  &:not(:last-child) {margin-bottom: ${toRem(4)};}
  &:has(+.tag) {
    margin-bottom: ${toRem(8)};
  }
`;

export const EmployeeRoleTag = styled.div`
  width: max-content;
  font-weight: 500;
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  padding: ${toRem(4)} ${toRem(8)};
  background-color: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  color: ${COLORS.NEUTRAL.DEFAULT};
  border-radius: ${toRem(8)};
`;

export const EmployeeActionsPopup = styled.div`
    //position: absolute;
    //top: calc(100% - 10px);
    //right: 0;
    width: max-content;
    height: max-content;
    background: ${COLORS.BG.SURFACE1};
    border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    z-index: 10;
    gap: 4px;
    display: flex;
    opacity: 1;
    flex-direction: column;
`

export const EmployeeActionsPopupElement = styled.div`
    padding: 6px 12px;   
    background: ${COLORS.BG.SURFACE1};
    transition: background .3s ease-in-out;
    border-radius: 8px;

    color: var(--dropdownmenu-primary-itemvalue-color-default, rgba(16, 24, 40, 1));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    cursor: pointer;
    &:hover {
        background: #eaeaec;
    }
`

export const EmployeeEditWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: ${toRem(40)};
  height: ${toRem(40)};
`;

export const MoreIconWrapper = styled.div`
  width: ${toRem(40)};
  height: ${toRem(40)};
  display: flex;
  justify-content:center;align-items: center;

  >span {
    display: flex;
    justify-content:center;align-items: center;
  }
`;

export const EmployeeDeleteWrapper = styled.div`
  padding: ${toRem(20)};
`;

export const EmployeeDeleteHead = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${toRem(12)};
  &:not(:last-child) {margin-bottom: ${toRem(20)};}
`;

export const EmployeeDeleteTitle = styled.h3`
  text-align: center;
  font-weight: 700;
  font-size: ${toRem(16)};
  line-height: ${24 / 16};
`;

export const EmployeeDeleteButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${toRem(12)};
`;

export const EmployeeNotFoundWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;  
text-align: center;
margin: 50px 0;
`;